<template>
  <div class="reveil-now-playing">
    <div class="reveil-now-playing__player-summary">
      <div class="reveil-now-playing__player-summary-info">
        <div class="reveil-now-playing__player-summary-info-title big-text">
          <span class="reveil-now-playing__live-now">LIVE NOW:&nbsp;</span>
          <span class="reveil-now-playing__live-now-location" v-if="stream" v-on:click="$emit('resetScrollerPosition');">
            {{ stream.attributes.location }}
          </span>
          <span v-else-if="reveilIsHappeningNow">See IRC Chat for details</span>
          <span v-else="reveilIsHappeningNow">Off air</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

// eslint-disable-next-line no-undef
export default {
  name: 'NowPlaying',
  props: ['stream', 'startTime', 'endTime', 'reveilIsHappeningNow'],
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/NowPlaying.vue